// const API_BASE_URL = "https://localhost:7034/api/Video/" ;

const API_BASE_URL = "https://crmapi.prowesserp.in/api/Video/" ;
export default API_BASE_URL;
